import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import HomePageTwo from "./pages/HomePageTwo";
import AddUserPage from "./pages/admins/AddUserPage";
import RouteScrollToTop from "./helper/RouteScrollToTop";
import AllAdminsPage from "./pages/admins/AllAdminsPage";
import { useState } from "react";
import { createContext } from "react";
import EditUserPage from "./pages/admins/EditUserPage";
import SignInPage from "./pages/SignInPage";
import ViewProfilePage from "./pages/ViewProfilePage";
import AllVehiclePage from "./pages/vehicles/AllVehiclePage";
import AddVehiclePage from "./pages/vehicles/AddVehiclePage";
import EditVehiclePage from "./pages/vehicles/EditVehiclePage";
import AllGaragePage from "./pages/garage/AllGaragePage";
import AddGaragePage from "./pages/garage/AddGaragePage";
import EditGaragePage from "./pages/garage/EditGaragePage";
import { AuthProvider } from "./components/context/AuthContext";
import ViewGaragePage from "./pages/garage/ViewGaragePage";
import AllBookingPage from "./pages/booking/AllBookingPage";
import ViewBookingPage from "./pages/booking/ViewBookingPage";
import AllServicesPage from "./pages/service-catalog/AllServicesPage";
import AddServicePage from "./pages/service-catalog/AddServicePage";
import EditServicePage from "./pages/service-catalog/EditServicePage";
import CategoryDetailPage from "./pages/service-catalog/CategoryDetailPage";
import ViewGarageReviewDetailPage from "./pages/garage-reviews/ViewGarageReviewDetailPage";
import AllGarageReviewPage from "./pages/garage-reviews/AllGarageReviewPage";
import AnnouncementsPage from "./pages/announcements/AnnouncementsPage";
const ModeContext = createContext();
const ProfileContext = createContext();
const UserPageContext = createContext();
const VehiclePageContext = createContext();
const GaragePageContext = createContext();
const BookingPageContext = createContext();

function App() {
  const [mode, setMode] = useState("light");
  const [profileUpdate, setProfileUpdate] = useState(0);
  const [userPage, setUserPage] = useState(0);
  const [vehiclePage, setVehiclePage] = useState(0);
  const [garagePage, setGaragePage] = useState(0);
  const [bookingPage, setBookingPage] = useState(0);

  return (
    <AuthProvider>
      <ModeContext.Provider value={{ mode, setMode }}>
        <ProfileContext.Provider value={{ profileUpdate, setProfileUpdate }}>
          <UserPageContext.Provider value={{ userPage, setUserPage }}>
            <VehiclePageContext.Provider
              value={{ vehiclePage, setVehiclePage }}
            >
              <GaragePageContext.Provider value={{ garagePage, setGaragePage }}>
                <BookingPageContext.Provider
                  value={{ bookingPage, setBookingPage }}
                >
                  <BrowserRouter>
                    <RouteScrollToTop />
                    <Routes>
                      <Route exact path="/sign-in" element={<SignInPage />} />
                      <Route exact path="/" element={<AllAdminsPage />} />
                      <Route
                        exact
                        path="/all-users"
                        element={<AllAdminsPage />}
                      />
                      <Route exact path="/add-user" element={<AddUserPage />} />
                      <Route
                        exact
                        path="/edit-user/:id"
                        element={<EditUserPage />}
                      />
                      <Route
                        exact
                        path="/all-vehicles"
                        element={<AllVehiclePage />}
                      />
                      <Route
                        exact
                        path="/add-vehicle"
                        element={<AddVehiclePage />}
                      />
                      <Route
                        exact
                        path="/edit-vehicle/:id"
                        element={<EditVehiclePage />}
                      />
                      <Route
                        exact
                        path="/all-garages"
                        element={<AllGaragePage />}
                      />
                      <Route
                        exact
                        path="/garage-details/:id"
                        element={<ViewGaragePage />}
                      />
                      <Route
                        exact
                        path="/add-garage"
                        element={<AddGaragePage />}
                      />
                      <Route
                        exact
                        path="/edit-garage/:id"
                        element={<EditGaragePage />}
                      />
                      <Route
                        exact
                        path="/all-bookings"
                        element={<AllBookingPage />}
                      />
                      <Route
                        exact
                        path="/booking-details/:id"
                        element={<ViewBookingPage />}
                      />
                      <Route
                        exact
                        path="/service-catalog"
                        element={<AllServicesPage />}
                      />
                      <Route
                        path="/service-category/:id"
                        element={<CategoryDetailPage />}
                      />
                      <Route
                        exact
                        path="/add-service"
                        element={<AddServicePage />}
                      />
                      <Route
                        exact
                        path="/edit-service/:id"
                        element={<EditServicePage />}
                      />
                      <Route
                        exact
                        path="/view-profile"
                        element={<ViewProfilePage />}
                      />
                      <Route
                        exact
                        path="/garage-reviews"
                        element={<AllGarageReviewPage />}
                      />
                      <Route
                        exact
                        path="/garage-reviews-detail/:id"
                        element={<ViewGarageReviewDetailPage />}
                      />
                      <Route
                        exact
                        path="/announcements"
                        element={<AnnouncementsPage />}
                      />
                      <Route exact path="*" element={<SignInPage />} />
                    </Routes>
                  </BrowserRouter>
                </BookingPageContext.Provider>
              </GaragePageContext.Provider>
            </VehiclePageContext.Provider>
          </UserPageContext.Provider>
        </ProfileContext.Provider>
      </ModeContext.Provider>
    </AuthProvider>
  );
}

export default App;
export {
  ProfileContext,
  UserPageContext,
  ModeContext,
  VehiclePageContext,
  GaragePageContext,
  BookingPageContext,
};
